import React, { FunctionComponent } from 'react'

export type Props = {}
export type Functions = {}
export type AllProps = Props & Functions

const Toolbar: FunctionComponent<AllProps> = ({}) => {
  return (
    <>
    </>
  )
}

export default Toolbar
